import { Typography } from '@persona-id/design-tokens';
import { SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

import { MonoSpan } from 'dashboard/components/Typography';
import SamlMetadataUrlForm from 'dashboard/forms/FormSamlMetadataUrl';
import { FormSamlMetadataUrlData } from 'dashboard/forms/FormSamlMetadataUrl/FormSamlMetadataUrl';
import SamlMetadataXmlForm from 'dashboard/forms/FormSamlMetadataXml';
import { FormSamlMetadataXmlData } from 'dashboard/forms/FormSamlMetadataXml/FormSamlMetadataXml';
import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import { Organization } from 'dashboard/models/organization';
import { COLORS } from 'dashboard/styles/variables';

const OrganizationSlug = styled('p')`
  ${Typography.TextMediumBold};
  margin-bottom: ${SPACINGS.base * 4}px;
`;

const Splitter = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: ${SPACINGS.base * 4}px 0px;
`;

const SplitterLine = styled('hr')`
  border-bottom: 1px solid ${COLORS.gray8};
  width: 100%;

  &:first-child {
    margin-right: ${SPACINGS.base * 2}px;
  }

  &:last-child {
    margin-left: ${SPACINGS.base * 2}px;
  }
`;

interface AddSamlInformationModalProps {
  organization: Organization;
  handleClose: () => void;
  handleSamlParseUrl: (values: FormSamlMetadataUrlData) => void;
  handleSamlParseXml: (values: FormSamlMetadataXmlData) => void;
}

/**
 * This can be tested via the fixture at spec/fixtures/saml/idp_metadata.xml.
 */
export default ({
  organization,
  handleClose,
  handleSamlParseUrl,
  handleSamlParseXml,
}: AddSamlInformationModalProps) => (
  <ModalContainer data-test='add-saml-information-modal'>
    <ModalHeader data-test='add-saml-information-modal__header' onClose={handleClose}>
      Set Up Single Sign-On
    </ModalHeader>

    <ModalBody>
      <OrganizationSlug>
        Organization Slug: <MonoSpan>{organization.attributes.slug}</MonoSpan>
      </OrganizationSlug>
      <SamlMetadataUrlForm onSubmit={handleSamlParseUrl} />
      <Splitter>
        <SplitterLine />
        or
        <SplitterLine />
      </Splitter>
      <SamlMetadataXmlForm onSubmit={handleSamlParseXml} />
    </ModalBody>
  </ModalContainer>
);
